import React, { Component } from 'react';
import { faLightbulb } from '@fortawesome/free-solid-svg-icons';
import { RowInfo } from 'react-table';
import moment from 'moment';

import { NormalizedClient } from '../../../models/normalized/normalizedClient';
import Button from '../../buttons/button';
import { AppTable, AppTableColumn } from '../../table/appTable';

import { EmailTemplateModal } from 'components/emailTemplate/emailTemplateModal';
import { SurveyTemplateModal } from 'components/surveyTemplate/surveyTemplateModal';
import { ClipPreviewRequestedModal } from 'components/clipPreviewRequested/clipPreviewRequestedModal';

type NotificationsTableState = {
  data: any[];
};

export class NotificationsTable extends Component<any, NotificationsTableState> {
  private columns: AppTableColumn[] = [
    {
      Header: 'Name',
      accessor: (client: NormalizedClient) => client.name,
      id: 'name',
    },
    {
      Header: 'Date time',
      accessor: ({
        emailUpdated,
        surveyUpdated,
        clipPreviewUpdated,
        emailTemplateUpdatedAt,
        surveyTemplateUpdatedAt,
        clipTemplateUpdatedAt,
      }: any) => {
        const dates = [];

        if (emailUpdated && emailTemplateUpdatedAt) {
          dates.push(moment(emailTemplateUpdatedAt));
        }

        if (surveyUpdated && surveyTemplateUpdatedAt) {
          dates.push(moment(surveyTemplateUpdatedAt));
        }

        if (clipPreviewUpdated && clipTemplateUpdatedAt) {
          dates.push(moment(clipTemplateUpdatedAt));
        }

        const date = moment.max(dates);

        if (date) {
          return date.toISOString();
        }

        return null;
      },
      id: 'date',
    },
    {
      Cell: (row: RowInfo) => {
        const { openEmailTemplatePreviewModal, openSurveyTemplatePreviewModal, openClipPreviewModal } = this.props;
        const { id, emailUpdated, surveyUpdated, clipPreviewUpdated } = row.original as NormalizedClient;

        return (
          <>
            <Button
              text="Email Template"
              onClick={() => openEmailTemplatePreviewModal(id)}
              icon={faLightbulb}
              allCapitals
              slimButton
              inverseColours={!emailUpdated}
            />

            <Button
              text="Survey Templates"
              onClick={() => openSurveyTemplatePreviewModal(id)}
              icon={faLightbulb}
              allCapitals
              slimButton
              inverseColours={!surveyUpdated}
            />

            <Button
              text="Clip Preview"
              onClick={() => openClipPreviewModal(id, clipPreviewUpdated)}
              icon={faLightbulb}
              allCapitals
              slimButton
              inverseColours={!clipPreviewUpdated}
            />
          </>
        );
      },
      Header: 'Actions',
      id: 'actions',
    },
  ];

  constructor(props: any) {
    super(props);

    this.state = {
      data: [],
    };
  }

  componentDidMount(): void {
    this.fetchData();
  }

  fetchData = () => {
    const { fetchNotifications } = this.props;

    fetchNotifications()
      .then(({ payload }: any) => {
        this.setState({ data: payload });
      })
      .catch(() => this.setState({ data: [] }));
  };

  render() {
    const { data } = this.state;

    return (
      <>
        <AppTable
          columns={this.columns}
          data={data}
          tableName="Notifications"
          defaultSorted={[{ id: 'date', desc: true }]}
        />
        <EmailTemplateModal onClose={this.fetchData} />
        <SurveyTemplateModal onClose={this.fetchData} />
        <ClipPreviewRequestedModal onClose={this.fetchData} />
      </>
    );
  }
}
